<script setup lang="ts">
import logoUrl from '@/assets/logo.webp'

withDefaults(defineProps<{ inverted?: boolean }>(), { inverted: false })
</script>

<template>
  <a href="/" class="logo" aria-label="MySmerra — Accueil">
    <img
      :src="logoUrl"
      alt="MySmerra"
      width="462"
      height="122"
      decoding="async"
      :class="['logo__img', { 'logo__img--inverted': inverted }]"
    />
  </a>
</template>

<style scoped>
.logo {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  line-height: 0;
}
.logo__img {
  height: 2.25rem;
  width: auto;
  object-fit: contain;
}
@media (min-width: 48rem) {
  .logo__img { height: 2.5rem; }
}
/* Variante sur fond sombre : on rend l'ensemble blanc */
.logo__img--inverted {
  filter: brightness(0) invert(1);
}
</style>
